import { Modal } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { BankAccountFormSchemaType } from '../../common';
import { AddBankAccountForm } from './components';

export type AddBankAccountModalPropsType = {
  opened: boolean;
  onClose: () => void;
  onSubmit: (data: BankAccountFormSchemaType) => Promise<void>;
};

export const AddBankAccountModal: React.FC<AddBankAccountModalPropsType> = ({
  opened,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation('common');

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="lg"
      title={t('ADD_BANK_ACCOUNT_MODAL.TITLE')}
    >
      <AddBankAccountForm onSubmit={onSubmit} onClose={onClose} />
    </Modal>
  );
};
